'use client';

import { useEffect } from 'react';

import PcError from '@/views/500/PcError';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Server Component Error:', error);
  }, [error]);

  return <PcError />;
}
